module.exports = __webpack_public_path__ + "img/btn5.ac7657cb.png";